import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';
import React from 'react';

const styles = require('./MissingDetailsList.module.scss');

export interface MissingDetailItem {
  icon: string;
  label: string;
}

export interface MissingDetailsListProps {
  ariaLabel?: string;
  className?: string;
  items: MissingDetailItem[];
  title?: string;
}

const MissingDetailsList: React.FC<MissingDetailsListProps> = ({
  ariaLabel = 'Missing profile details',
  className,
  items,
  title = 'Make it 100% by adding',
}) => {
  if (!items?.length) return null;

  return (
    <section className={classNames(styles.container, className)} aria-label={ariaLabel}>
      <p className={styles.title}>{title}</p>
      {items.map((item, index) => (
        <div key={`${item.icon}-${index}`} className={styles.item}>
          <Icon name={item.icon} size="md" color="neutral-text-dark" aria-hidden="true" />
          <span className={styles.itemLabel}>{item.label}</span>
        </div>
      ))}
    </section>
  );
};

export default MissingDetailsList;
